export default function MediaKitGuidePage() {
  return (
    <section className="section-padding bg-light">
      <div className="container px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-dark mb-4">Media kit guide</h1>
            <p className="text-xl text-gray-600 font-dm-sans">
              A complete guide to creating an influencer media kit and why a live profile beats traditional PDF media kits.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg prose prose-lg max-w-none">
            <p className="text-gray-600 mb-4">
              Your InfluenceHub profile is your media kit, always up to date, shareable with one link, and built to show brands your platforms, audience, and best content.
            </p>
            <p className="text-gray-600 mb-6">
              Include your niche, follower counts, engagement rates, audience demographics, and past brand collaborations. No more static PDFs or Canva decks.
            </p>
            <a href="/signup" className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white bg-primary hover:bg-primary/90 transition font-dm-sans">
              Create your profile →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
